import { ProductDetailsScreen } from '../../../../screens';

// ─────────────────────────────────────────────────────────────────────────────

export default function Page() {
  return <ProductDetailsScreen />;
}
